import React, { useEffect, useRef, useState } from "react";

// components imports
import CircularLoader from "../../../../../../Components/CircularLoader/CircularLoader";
import ConformModal from "../conformModal";
import CustomDropdown from "../customdropdown";
import Tooltip from "../../../../../../Components/Tooltip/Tooltip";
import FullfilmentBillingStatusHistoryModal from "../../../../../Shipper/Customer/MainPages/Orders/Components/FullfilmentBillingStatusHistoryModal/FullfilmentBillingStatusHistoryModal";

// apis imports
import { storeAdditionlCost } from "../../../../../../services/orders.services";
import { useOrderVisibility } from "../../../../../../helpers/useOrderVisibility";

// library imports
import { FcPlus } from "react-icons/fc";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import MenuItem from "@mui/material/MenuItem";
import { TextField } from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import Select from "@mui/material/Select";
import { MdOutlineHistory } from "react-icons/md";
import { useTranslation } from "react-i18next";

export default function Fulfilment({
  data,
  setadditionalCosts,
  AdditionalCostTotal,
  setAdditionalCostTotal,
  additionalCosts,
  editable,
  deletedids,
  setdeletedids,
  setSnack,
  setData,
  setOrders,
  cost,
  setcost,
  value,
  setValue,
  open,
  additonalPrice,
  setadditonalPrice,
  selectedStatus,
  setselectedStatus,
  orderStatus,
  type = "show",
  initial = false,
}) {
  const { t } = useTranslation(["warehouse", "common"]);
  const [CostCheck, setCostCheck] = useState([false]);
  const [loader, setloader] = useState(false);
  const [statusModal, setstatusModal] = useState(initial);
  const [qty, setQty] = React.useState(1);
  const [billingNotesHistoryModal, setBillingNotesHistoryModal] =
    useState(false);
  const setAdditionalCostRef = useRef(false);
  setAdditionalCostRef.current = false;
  // Costs and charges need "View price"; the status (and its confirm
  // pop-up) is for every role that may fulfil.
  const { showPrices } = useOrderVisibility();

  useEffect(() => {
    if (!open[2]) {
      const selected =
        orderStatus.find(
          (status) => status.id === parseFloat(data?.fullfilment_status?.id)
        )?.id ?? "";
      setselectedStatus(selected);
    }
  }, [orderStatus]);

  useEffect(() => {
    if (setAdditionalCostRef.current === false && data?.additional_costs) {
      setadditionalCosts(
        data?.additional_costs.map((cost) => {
          return { ...cost, name: cost.cost_type?.name };
        })
      );
      let totalCost;
      if (data?.additional_costs?.length > 0) {
        totalCost = data?.additional_costs.reduce(
          (accumulator, currentItem) => {
            const cost = parseFloat(currentItem.cost);
            return accumulator + cost;
          },
          0
        );
      }
      setadditonalPrice(totalCost);
      setAdditionalCostRef.current = true;
    }
  }, [data.additional_costs]);

  const storeAdditonaldata = async () => {
    setloader(true);
    let response;
    try {
      const newData = additionalCosts.filter((item) => !item.id);
      const Array = {
        new: newData.map(({ name, ...rest }) => rest),
        del: deletedids,
      };
      response = await storeAdditionlCost(Array, data.id);
      if (!response.error) {
        setloader(false);
        setdeletedids([]);
        setOrders((prevOrder) => {
          return {
            ...prevOrder,
            data: prevOrder?.data.map((order) =>
              order.id === data.id
                ? { ...order, additional_costs: response?.data?.result }
                : order
            ),
          };
        });
        setData({
          ...data,
          additional_costs: response?.data?.result,
        });
        setCostCheck(false);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: response?.data?.message,
            severity: "success",
          };
        });
        // setadditionalCosts([]);
      } else {
        setloader(false);
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("orderDetails.somethingWentWrongTryAgainLater"),
            severity: "error",
          };
        });
      }
    } catch (error) {
      setloader(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: error.response.data.message,
          severity: "error",
        };
      });
    }
  };

  const handlestatusChange = (e) => {
    setselectedStatus(e.target.value);
    setstatusModal(true);
  };

  const handleRemoveCost = async (index, data) => {
    if (data.id) {
      setdeletedids([...deletedids, data.id]);
    }
    const list = [...additionalCosts];
    list.splice(index, 1);
    setadditionalCosts(list);
  };

  const handleadditionalcost = () => {
    if (!value) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("orderDetails.costTypeIsRequired"),
          severity: "error",
        };
      });
      return;
    }
    const quantity = parseInt(qty) || 1; // Default to 1 if qty is not set or invalid
    const parsedCost = parseFloat(cost) || 0;
    const totalCost = parsedCost * quantity;

    // Update additional price based on quantity
    let x = parseFloat(additonalPrice) + totalCost;
    setadditonalPrice(x);

    // Add entries qty times
    const newCosts = Array.from({ length: quantity }, () => ({
      costtype_id: value.id,
      cost: cost,
      name: value.name,
      order_id: data?.id,
    }));

    setadditionalCosts([...additionalCosts, ...newCosts]);

    // Clear input values
    setcost(null);
    setValue(null);
    setQty(1); // set back to 1
  };

  useEffect(() => {
    let y = 0;
    if (additionalCosts.length > 0) {
      additionalCosts.forEach((element) => {
        y = y + parseFloat(element.cost);
      });
    }
    setAdditionalCostTotal(y);
    const newData = additionalCosts.filter((item) => !item.id);
    if (deletedids.length > 0 || newData.length > 0) {
      setCostCheck(true);
    } else {
      setCostCheck(false);
    }
  }, [additionalCosts]);

  return (
    <>
      <ConformModal
        data={data}
        setData={setData}
        open={statusModal}
        setOpen={setstatusModal}
        selectedStatus={selectedStatus}
        orderStatus={orderStatus}
        setOrders={setOrders}
        setselectedStatus={setselectedStatus}
        setSnack={setSnack}
      />

      <FullfilmentBillingStatusHistoryModal
        open={billingNotesHistoryModal}
        setOpen={setBillingNotesHistoryModal}
        setSnack={setSnack}
      />
      <Row className="fulfilment_info_title_row">
        {/* Without prices, read-only, the section has nothing to show. */}
        {(showPrices || editable) && (
          <div
            className="invmodal__shipment_detailshding"
            style={{ marginBottom: "10px" }}
          >
            {t("orderDetails.fulfilmentInformation")}
          </div>
        )}
        {editable && (
          <Col
            md={8}
            className="package__name_list_wrap fulfilment_information_form_wrap"
          >
            <div className="package__name_list_fulfilment_list">
              <div className="addprod__custominput_box">
                <label className="addprod__custominput_title">
                  {t("orderDetails.saleStatus")}
                </label>
                <Tooltip
                  title={
                    data?.type === "Return"
                      ? t("orderDetails.thisOrderIsAReturn")
                      : data?.status !== "Confirmed"
                      ? t("orderDetails.thisOrderIsNotConfirmedYet")
                      : ""
                  }
                >
                  <Select
                    value={selectedStatus}
                    onChange={(e) => handlestatusChange(e)}
                    label={t("orderDetails.orderStatus")}
                    style={{ width: "100%", fontSize: "10px" }}
                    size="small"
                    disabled={
                      selectedStatus == "6" ||
                      data?.status !== "Confirmed" ||
                      data?.type === "Return"
                        ? true
                        : false
                    }
                  >
                    {orderStatus.map((Status) => (
                      <MenuItem
                        key={Status.id}
                        value={Status.id}
                        disabled={Boolean(Status?.disabled)}
                      >
                        {Status.name.toUpperCase()}
                      </MenuItem>
                    ))}
                  </Select>
                </Tooltip>
              </div>
              {showPrices && (
                <>
                  <div className="custom__drop_order_details">
                    {type === "show" && (
                      <CustomDropdown
                        setValue={setValue}
                        value={value}
                        setcost={setcost}
                      />
                    )}
                  </div>
                  <div className="details_modal_fulfilment_cost_wrap">
                    <TextField
                      label={t("orderDetails.cost")}
                      type="number"
                      name="cost"
                      style={{ fontSize: "10px" }}
                      value={cost || ""}
                      onChange={(e) => setcost(e.target.value)}
                      placeholder={t("orderDetails.cost")}
                      inputProps={{ style: { fontSize: 10 } }}
                      InputLabelProps={{
                        shrink: true,
                        style: { fontSize: 10 },
                      }}
                      size="small"
                    />
                    <TextField
                      label={t("orderDetails.qty")}
                      type="number"
                      name="Qty"
                      style={{ fontSize: "10px" }}
                      value={qty || ""}
                      onChange={(e) => setQty(e.target.value)}
                      placeholder={t("orderDetails.qty")}
                      inputProps={{ style: { fontSize: 10 } }}
                      InputLabelProps={{
                        shrink: true,
                        style: { fontSize: 10 },
                      }}
                      size="small"
                    />
                    <FcPlus
                      size={20}
                      onClick={() => handleadditionalcost()}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </>
              )}
            </div>
          </Col>
        )}
        {showPrices && (
          <Col
            md={4}
            className="package__name_list_wrap fulfiment_box_wrap"
            style={{ border: "1px solid var(--color-ui-border)", padding: "20px" }}
          >
            <strong className="fulfilment_box_title">{t("orderDetails.fulfilmentCost")} </strong>{" "}
            <div className="fulfilment_data_row">
              <label>
                <strong>
                  {data?.formula?.["UnitType"] === "CBM" ? t("orderDetails.volume") : t("orderDetails.weight")}: (
                  {data?.formula?.["TotalFulfilmentWeight"] ?? 0}{" "}
                  {data?.formula?.["UnitType"]})
                </strong>
              </label>
              <span>
                <strong>{data?.formula?.["TotalWeightCost"] ?? 0} {t("units.cad")} </strong>
              </span>
            </div>
            {data?.formula?.["TotalPreProduct"] > 0 && (
              <>
                <hr />
                <div className="fulfilment_data_row">
                  <label>
                    <strong>
                      {t("orderDetails.preCostItemQuantity", {
                        quantity: data?.formula?.["TotalPreProduct"],
                      })}
                    </strong>
                  </label>
                  {/* <span>{data?.formula?.["TotalPreCost"]} CAD </span> */}
                </div>
                {data?.order_details
                  ?.filter((singlelist) => singlelist?.products?.fulfillment_cost)
                  .map((list, index) => (
                    <div
                      className="fulfilment_data_row"
                      key={index} // It's a good 5practice to provide a unique key for each mapped element
                    >
                      <label>
                        {list.product_name} ({list.item_quantity} x{" "}
                        {list.products?.fulfillment_cost})
                      </label>
                      <span>
                        {list.products?.fulfillment_cost * list.item_quantity} {t("units.cad")}{" "}
                      </span>
                    </div>
                  ))}
                <div className="fulfilment_data_row">
                  <label>{/* <strong>Total:</strong> */}</label>
                  <span>
                    <strong>{data?.formula?.["TotalPreCost"]} {t("units.cad")}</strong>{" "}
                  </span>
                </div>
              </>
            )}
            {additionalCosts?.length > 0 && (
              <>
                <hr />
                <div className="fulfilment_data_row">
                  <label>
                    <strong>
                      {t("orderDetails.additionalCostCount", { number: additionalCosts?.length })}
                    </strong>
                  </label>
                  {/* <span>{data?.formula?.["TotalPreCost"]} CAD </span> */}
                </div>
                {additionalCosts?.map((list, index) => (
                  <div
                    className="fulfilment_data_row"
                    key={index} // It's a good 5practice to provide a unique key for each mapped element
                  >
                    <label>{list.name}</label>
                    <span style={{ display: "flex" }}>
                      {list?.cost} {t("units.cad")}
                      {editable && (
                        <RxCross2
                          style={{
                            margin: "auto",
                            color: "red",
                            cursor: "pointer",
                          }}
                          onClick={() => handleRemoveCost(index, list)}
                        />
                      )}
                    </span>
                  </div>
                ))}
                <div className="fulfilment_data_row">
                  <label>
                    <strong>{t("orderDetails.totalAdditionalCost")}</strong>
                  </label>
                  <span>
                    <strong>{AdditionalCostTotal} {t("units.cad")}</strong>{" "}
                  </span>
                </div>
                <hr />
              </>
            )}
            {type === "show" && (
              <>
                <label>
                  <strong>{t("orderDetails.fullfullmentBillingNote")} </strong>
                </label>
                <div className="details_billingstatus__history_icon_wrapper">
                  <div style={{ fontSize: "12px" }}>
                    {data?.fullfullment_billing_status_history?.at(-1)?.properties
                      ?.notes ?? t("orderDetails.noNoteAvailable")}
                  </div>
                  <div>
                    <MdOutlineHistory
                      size={15}
                      className="details_billingstatus__history_icon"
                      onClick={() => setBillingNotesHistoryModal(data)}
                    />
                  </div>
                </div>
              </>
            )}
            <div className="fulfilment_data_row total_fulfilment_cost">
              <label>
                <strong>{t("orderDetails.totalFulfilmentCostColon")} </strong>
              </label>
              <span>
                <strong>
                  {parseFloat(
                    parseFloat(data?.formula?.["TotalFulfilmentCost"]) +
                      AdditionalCostTotal
                  ).toFixed(2)}{" "}
                  {t("units.cad")}{" "}
                </strong>
              </span>
            </div>
          </Col>
        )}
      </Row>
      {showPrices && CostCheck && editable && (
        <div className="deatil_modal_footer_btn_save">
          <div
            className="prodidentifier__desc_modalsave"
            onClick={() => storeAdditonaldata()}
          >
            {loader ? <CircularLoader /> : t("common:actions.save")}
          </div>
        </div>
      )}
    </>
  );
}
